const funfacts = [
    "Women make up 80% of all refugees and displaced people. Instruments of genocide such as sexual violence and rape are often directed at women and girls.",
    "Women are seldom included in formal peace processes. Women are usually not represented among decision-makers and military leaders, the usual participants in these processes.",
    "Women gained the right to vote in America in 1920.",
    "As of January 2012, women held 15.1% of all presiding officer posts in governments the world.",
    "Women account for 70% of the population living in absolute poverty (on less than $1.00 a day).",
    "Over 60 million girls worldwide are child brides, married before the age of 18.",
  ];
  
  export default funfacts;